<script>
    import StarRating from 'vue-star-rating';
    export default {
        components: {
          StarRating
        },
        props: [
            'courseprop',
            'scoresprop'

        ],
        data() {
            return {
                course: null,
                scores: {
                    total_score: 0,
                    technical_score: 0,
                    inclusiveness_score: 0,
                    cleanliness_score: 0,
                    equipment_score: 0
                },
                reviews_avg_score: 0
            }
        },
        mounted() {
            this.course = this.courseprop;
            this.reviews_avg_score = this.course.reviews_avg_score;
            if (!_.isEmpty(this.scoresprop)) {
                this.scores.total_score = this.scoresprop['total_score'] * 1;
                this.scores.technical_score = this.scoresprop['technical_score'];
                this.scores.inclusiveness_score = this.scoresprop['inclusiveness_score'];
                this.scores.cleanliness_score = this.scoresprop['cleanliness_score'];
                this.scores.equipment_score = this.scoresprop['equipment_score'];
            }
        },
        methods: {}

        /*watch: {
            review: {
                handler: function () {
                    this.review.total_score = ((parseInt(this.review.technical_preparation_score) + parseInt(this.review.inclusive_environment_score) + parseInt(this.review.cleanliness_score) + parseInt(this.review.equipment_score))/4).toFixed(1);
                },
                deep: true,
            },
        },*/
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseReviews.vue